import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { searchProductAdvPlatform } from "@/api/dataAll/dataAll";
import { productList } from "@/api/management/productMapping";
import { getCountry } from "@/api/dataAll/new";
import { listNo } from "@/api/advRelation";
import { getGame, getCurrencyList, getMultiPayChannel } from "@/api/serchSelect";
import store from "@/store/index";
import utils from "@/utils/utils.js";
export default {
  namespaced: true,
  state: {
    advchannels: [],
    productsList: [],
    searchCountry: [],
    //
    searchCurrency: [],
    payChannel: [],
    // 支付渠道
    productAll: [],
    gameAll: [],
    rawData: {
      game: "",
      game_mark: "",
      game_id: ""
    },
    // 当前选择的产品或游戏数据
    HomePageState: "",
    sericeArr: [],
    //汇总数据存储列表
    royalpirates: "royalpirates",
    // 海盗权限判断字符
    isreqCurrency: false,
    isreqPayList: false,
    isreqCountryList: false,
    homeEvents: "asdsaqweq"
  },
  actions: {
    // 清除游戏数据
    clearData: function clearData(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      state.productsList = [];
      state.productAll = [];
      state.gameAll = [];
      state.advchannels = [];
      state.searchCountry = [];
      state.payChannel = [];
      state.isreqCurrency = false;
      state.isreqPayList = false;
      state.isreqCountryList = false;
      state.rawData = {
        game: "",
        game_mark: "",
        game_id: ""
      };
      dispatch("setPageStatus", type);
    },

    /**
     * 首页状态控制
     * @param {*} params
     * @param {*} type  1显示游戏 2显示功能菜单 3显示上宅游戏
     */
    setPageStatus: function setPageStatus(_ref2, type) {
      var commit = _ref2.commit;
      commit("setHomePageState", type);
    },

    /**
     * 用于关于包相关修改后更新游戏数据
     * @param {*} param0
     * @param {*} items 游戏数据
     */
    setGame: function setGame(_ref3, items) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(replace, reject) {
          var primitive, data;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  primitive = {
                    productsList: state.productsList,
                    advchannels: [],
                    rawData: items ? items : state.rawData
                  };
                  _context.next = 4;
                  return commit("setrawData", primitive.rawData);

                case 4:
                  if (store.state.d2admin.user.is_show_home == 1) {
                    replace({
                      code: 200
                    });
                  }

                  if (!(items && items.game_show_type == 1)) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 8;
                  return productList({
                    game_id: items.game_id
                  }).then(function (res) {
                    if (res.status == 200) {
                      primitive.productsList = res.data;
                    }
                  });

                case 8:
                  data = {
                    game_id: primitive.rawData.game_id,
                    special_product_id: primitive.rawData && primitive.rawData.game_show_type == 1 ? "" : primitive.rawData.id
                  };
                  _context.next = 11;
                  return dispatch("getAdvPlarform", data);

                case 11:
                  primitive.advchannels = _context.sent;

                  if (!(store.state.d2admin.user.is_show_home == 2)) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 15;
                  return dispatch("updCurrency", data);

                case 15:
                  _context.next = 17;
                  return commit("setProducts", primitive);

                case 17:
                  if (!(store.state.d2admin.user.is_show_home == 2)) {
                    _context.next = 25;
                    break;
                  }

                  replace({
                    code: 200
                  });
                  _context.next = 21;
                  return dispatch("getCountryList");

                case 21:
                  _context.next = 23;
                  return dispatch("getPayList");

                case 23:
                  _context.next = 25;
                  return commit("sethomeEvents");

                case 25:
                  _context.next = 30;
                  break;

                case 27:
                  _context.prev = 27;
                  _context.t0 = _context["catch"](0);
                  reject({
                    code: 500,
                    data: _context.t0
                  });

                case 30:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 27]]);
        }));

        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 更新广告渠道
    updadvchannels: function updadvchannels(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var state, commit, dispatch, data, advchannels;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref5.state, commit = _ref5.commit, dispatch = _ref5.dispatch;
                data = {
                  game_id: state.rawData.game_id,
                  special_product_id: state.rawData && state.rawData.game_show_type == 1 ? "" : state.rawData.id
                };
                _context2.next = 4;
                return dispatch("getAdvPlarform", data);

              case 4:
                advchannels = _context2.sent;
                commit("setAdvchannels", advchannels);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 更新货币类型
    updCurrency: function updCurrency(_ref6, data) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var state, commit, dispatch, list;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref6.state, commit = _ref6.commit, dispatch = _ref6.dispatch;
                _context3.next = 3;
                return dispatch("getCurrency", data);

              case 3:
                list = _context3.sent;
                _context3.next = 6;
                return commit("setreqCurrency", true);

              case 6:
                commit("setCurrency", list);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 获取广告渠道
    getAdvPlarform: function getAdvPlarform(_ref7, data) {
      var state = _ref7.state,
          commit = _ref7.commit;
      return new Promise(function (resolve, reject) {
        if (!data.game_id && !data.special_product_id) {
          resolve([]);
          return;
        }

        searchProductAdvPlatform(data).then(function (res) {
          if (res.status == 200) {
            // let list = res.data.findIndex((i) => i.adv_platform_mark == "default") == -1 ? [{ adv_platform_mark: "default", adv_platform_name: "默认", adv_place_data: [{ adv_place_mark: "default", adv_place_name: "默认" }] }, ...res.data] : res.data;
            res.data.map(function (i) {
              i.adv_place_data.map(function (j) {
                j.adv_place_mark = j.adv_place_mark ? j.adv_place_mark : "valuets";
              });
            });
            resolve(res.data);
          }
        });
      });
    },
    // 获取所有产品
    getAllProduct: function getAllProduct(_ref8) {
      var commit = _ref8.commit;
      listNo().then(function (res) {
        if (res.status == 200) {
          commit("setProductAll", res.data);
        }
      });
    },
    // 获取所有游戏
    getAllGame: function getAllGame(_ref9) {
      var commit = _ref9.commit;
      getGame().then(function (res) {
        if (res.status == 200) {
          commit("setGameAll", res.data.game);
        }
      });
    },
    // 获取货币类型
    getCurrency: function getCurrency(_ref10, data) {
      var commit = _ref10.commit,
          state = _ref10.state;
      return new Promise(function (resolve, reject) {
        if (data.game_id) {
          getCurrencyList(_objectSpread({}, data)).then(function (res) {
            if (res.status == 200) {
              resolve(res.data);
            }
          });
        } else {
          resolve([]);
        }
      });
    },
    // 获取支付渠道类型
    getPayList: function getPayList(_ref11, data) {
      var commit = _ref11.commit,
          state = _ref11.state;
      return new Promise(function (resolve, reject) {
        var game_id = state.rawData.game_id;

        if (game_id) {
          var _data = {
            game_id: game_id,
            special_product_id: state.rawData.game_show_type == "2" ? state.rawData.id : ""
          };
          getMultiPayChannel(_data).then(function (res) {
            if (res.status == 200) {
              commit("setpayChannel", res.data);
              commit("setreqPayList", true);
              resolve(res.data);
            }
          });
        } else {
          resolve([]);
        }
      });
    },
    getCountryList: function getCountryList(_ref12, data) {
      var commit = _ref12.commit,
          state = _ref12.state;
      return new Promise(function (resolve, reject) {
        getCountry().then(function (res) {
          if (res.status == 200) {
            commit("setsearchCountry", res.data);
            commit("setreqCountryList", true);
          }
        }).finally(function () {
          resolve();
        });
      });
    }
  },
  mutations: {
    setHomePageState: function setHomePageState(state, data) {
      state.HomePageState = data;
    },
    setProductAll: function setProductAll(state, data) {
      state.productAll = data;
    },
    setGameAll: function setGameAll(state, data) {
      state.gameAll = data;
    },
    setProducts: function setProducts(state, data) {
      state.productsList = data.productsList;
      state.rawData = _objectSpread({}, data.rawData);
      state.advchannels = data.advchannels;

      this._vm.$bus.$emit("upd");
    },
    setrawData: function setrawData(state, data) {
      state.rawData = _objectSpread({}, data);
    },
    setAdvchannels: function setAdvchannels(state, data) {
      state.advchannels = data;

      this._vm.$bus.$emit("upd");
    },
    setsericeArr: function setsericeArr(state, data) {
      state.sericeArr = data;
    },
    setCurrency: function setCurrency(state, data) {
      state.searchCurrency = data;

      this._vm.$bus.$emit("updCurrency");
    },
    setpayChannel: function setpayChannel(state, data) {
      state.payChannel = data;
    },
    setsearchCountry: function setsearchCountry(state, data) {
      state.searchCountry = data;
    },
    setreqCurrency: function setreqCurrency(state, data) {
      state.isreqCurrency = data;
    },
    setreqPayList: function setreqPayList(state, data) {
      state.isreqPayList = data;
    },
    setreqCountryList: function setreqCountryList(state, data) {
      state.isreqCountryList = data;
    },
    sethomeEvents: function sethomeEvents(state) {
      state.homeEvents = utils.randomString();
    }
  }
};